import { api } from "../api/Middleware";
import { TEMPLATES_URL } from "../api/Urls";

// Obter lista de templates
export const getTemplates = async () => {
  try {
    const response = await api.get(TEMPLATES_URL);
    return response.data;
  } catch (error) {
    console.error("Erro ao obter templates:", error);
    throw error;
  }
};

// Obter um template específico
export const getTemplate = async (id) => {
  try {
    const response = await api.get(`${TEMPLATES_URL}${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Erro ao obter template ${id}:`, error);
    throw error;
  }
};

// Criar novo template
export const createTemplate = async (templateData) => {
  try {
    const response = await api.post(TEMPLATES_URL, templateData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao criar template:", error);
    throw error;
  }
};

// Atualizar template existente
export const updateTemplate = async (id, templateData) => {
  try {
    const response = await api.patch(`${TEMPLATES_URL}${id}/`, templateData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error(`Erro ao atualizar template ${id}:`, error);
    throw error;
  }
};

// Excluir template
export const deleteTemplate = async (id) => {
  try {
    const response = await api.delete(`${TEMPLATES_URL}${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Erro ao excluir template ${id}:`, error);
    throw error;
  }
};

export const bulkDelete = async (payload, setNotify) => {
  try {
    let response = await api.delete(TEMPLATES_URL + "bulk_delete/", {
      data: payload,
    });
    if (response.status === 200) {
      setNotify({
        title: "Sucesso!",
        message: "Operação realizada com sucesso!",
        type: "success",
        visible: true,
      });
      window.location.href = "/templates";
      return true;
    }
  } catch (error) {
    console.log(error);
    //if(error.status !== 401) throw error.response;
    setNotify({
      title: "Oops!",
      message: error.response.data,
      type: "error",
      visible: true,
    });
  }
};
